import React from 'react';
import { applyComponentTheme } from '../../../../theme';
import { TextInputProps } from '../../TextInput';
import { InputComponent } from '../../inputTypes';
import NarrowTextInput from '../NarrowTextInput';

const MonthInput: InputComponent<Omit<
  TextInputProps,
  'numbersOnly' | 'maxLength' | 'placeholder'
>> = (props) => <NarrowTextInput {...props} numbersOnly maxLength={2} placeholder="MM" />;

export default applyComponentTheme(MonthInput, 'MonthInput');
